module.exports = __webpack_public_path__ + "img/DEBIT-payment.836b2daf.png";